import { datePickerContainerClass } from '../../styles';

interface DatePickerWrapperProps {
  children: React.ReactNode;
  showTime: boolean;
  showTimeSelectOnly?: boolean;
  renderCustomFooter?: () => React.ReactNode;
}

export const DatePickerWrapper = ({
  children,
  showTime,
  renderCustomFooter,
  showTimeSelectOnly,
  ...rest
}: DatePickerWrapperProps) => {
  return (
    <div className={datePickerContainerClass()} {...rest}>
      {children}
      {renderCustomFooter && renderCustomFooter()}
    </div>
  );
};